import CMSActionPage from "./CMSActionPage";

export default CMSActionPage;
